import React from 'react';
import styled from 'styled-components';
import { sizes } from 'ui/media';
import { isMobile } from 'utils/platform';
import ClothRailImage from '../images/cloth-rail-img.png';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import { useIntl } from 'react-intl';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import SkapaHyperLink from '@ingka/hyperlink';
import {
  QuestionSheetState,
  setQuestionSheetVisible,
  setQuestionSheetVisibleWithProps
} from 'ducks/questionSheet';
import { useAppDispatch } from 'ducks/hooks';
import clothRailInstructionImg from '../images/cloth-rail-instruciton-img.png';

const Wrapper = styled.div`
  margin: 0 -${({ theme }) => (isMobile() ? 0 : theme.space.xxl)};
`;

const Image = styled.img`
  width: 100%;
  height: 10rem;
  object-fit: cover;
  margin: 1rem 0;
`;

export const ClothRailInfo = () => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();

  const openClothRailInstuctionSheet = () => {
    dispatch(
      setQuestionSheetVisibleWithProps({
        modalVisible: true,
        title: 'storageone.extendableClothRailInfoSheetTitle',
        preamble: 'storageone.extendableClothRailInfoSheetBody',
        primaryButtonText: 'storageone.extendableClothRailInfoSheetButtonPrimary',
        onAccept: () => {
          dispatch(setQuestionSheetVisible(false));
        },
        imageRealtivePath: clothRailInstructionImg
      } as QuestionSheetState)
    );
  };

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openClothRailInstuctionSheet();
  };

  return (
    <>
      <Wrapper>
        <Image
          src={ClothRailImage}
          alt={'cloth-rail-image'}
          sizes={`(max-width: ${sizes.mobile.max}px) 110px, 250px`}
        />
      </Wrapper>
      <SkapaInlineMessage
        body={
          <>
            <span>{formatMessage({ id: 'storageone.extendableClothRailInfo' })}</span>
            <SkapaHyperLink
              button
              subtle
              text={` ${formatMessage({
                id: 'storageone.extendableClothRailInfoAction'
              })}`}
              onClick={onClick}
            />
          </>
        }
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </>
  );
};
